import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GameProviderHttpService } from '@core/services/game-provider-http.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-sitemap',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './sitemap.component.html',
  styleUrl: './sitemap.component.scss',
})
export class SitemapComponent implements OnInit {

  groupData: Record<string, any[]> = {};
  sortedData: { key: string; value: any[] }[] = [];
  categoryOrder = ['LC', 'SL', 'FS', 'CG', 'TB'];
  projectCode = environment.projectCode;
  no_data: any;

  constructor(
    private gameProviderHttpService: GameProviderHttpService
  ) { }

  ngOnInit(): void {
    // Get sitemap listing
    this.getListing();
  }

  getListing() {
    this.gameProviderHttpService.getSitemap('?project_code=' + this.projectCode.toUpperCase()).subscribe(res => {
      this.no_data = res.length == 0;
      this.groupData = res.reduce((acc: Record<string, any[]>, item: any) => {
        if (!acc[item.category_name]) {
          acc[item.category_name] = [];
        }
        acc[item.category_name].push(item);
        return acc;
      }, {} as Record<string, any[]>);

      // Sort by custom ordering
      this.sortCategories();
    });
  }

  sortCategories() {
    // Convert groupedData into an array and sort based on the predefined order
    this.sortedData = Object.entries(this.groupData)
      .map(([key, value]) => ({ key, value }))
      .sort((a, b) => {
        return this.categoryOrder.indexOf(a.key) - this.categoryOrder.indexOf(b.key);
      });
  }

  intoTitleCase(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

}
